import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, formatDate } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@lib/models/breadcrumb.model';
import { DialogService } from '@app/lib/services/dialog.service';
import { HearingScheduleService } from '../services/hearing-schedule.service';
import { IResponse } from '@app/lib/models/response.model';
import { TAny, TKeyValue } from '@app/lib/models/common.type';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ILoginData } from '@app/lib/models/login.model';
import { ECaseCategory } from '../models/constant';
import { MatSelectModule } from '@angular/material/select';
import { ISearchRequestParams } from '../models/case-assignment.model';
import { DashboardComponent } from '../dashboard.component';
import { AssignedTaskService } from '../services/assigned-task.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { ETaskScreenName, IAssignedTask, IAssignedTaskEvent } from '../models/assigned-task.model';
import { IJudgementData } from '../models/judgementDate.model';
import { CaseDocumentsComponent } from "../case-documents/case-documents.component";


@Component({
  selector: 'app-judgement-schedule',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatDatepickerModule,
    ScrollingModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    BreadcrumbComponent,
    MatSelectModule,
    CaseDocumentsComponent
  ],
  templateUrl: './judgement-date.component.html',
  styleUrl: './judgement-date.component.scss'
})
export class JudgementDateComponent implements OnInit, AfterViewInit {


  @ViewChild(MatSort) matSortRef!: MatSort;

  public caseCategoryEnum = ECaseCategory;

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([]);
  public isLoading: boolean = false;
  public caseNumber: WritableSignal<string> = signal('');
  public task: WritableSignal<IAssignedTask | null> = signal(null);


  public searchForm: FormGroup = new FormGroup({
    judgementPhaseName: new FormControl('', [Validators.required]),
    caseCategory: new FormControl('', [Validators.required])
  });

  public displayedColumns: string[] = ['caseNumber', 'division', 'court', 'judgementDate', 'actions'];
  public dataSource: MatTableDataSource<IJudgementData> = new MatTableDataSource();
  public judgementPhases: { key: string; value: string }[] = [
    { key: 'Judgement Date To Be Fixed', value: 'Judgement Date To Be Fixed' },
    { key: 'Judgement Date Fixed', value: 'Judgement Date Fixed' },
    { key: 'Ruling Date Fixed', value: 'Motion - Judgement Date Fixed' },
    { key: 'Ruling Date To Be Fixed', value: 'Motion - Judgement Date To Be Fixed' }
  ];
  public selectedComment: WritableSignal<string> = signal('');
  public caseCategories: TKeyValue[] = [
    { key: this.caseCategoryEnum.FI, value: 'First Instance' },
    { key: this.caseCategoryEnum.A, value: 'Appeal' },
  ];
  isSupremeFlag: boolean = false;
  isCOAflag: boolean = false;
  isAppeal: boolean = false;
  ispanel: boolean = false;

  constructor(
    private service: HearingScheduleService,
    private assignTaskService: AssignedTaskService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private dashboard: DashboardComponent
  ) {
    this.assignTaskService.assignTask$
      .pipe(
        takeUntilDestroyed(),
        filter(event => event.name === ETaskScreenName.JUDGEMENTSCHEDULE)
      )
      .subscribe({
        next: (event: IAssignedTaskEvent) => {
          this.caseNumber.set('');
          this.cdr.detectChanges();
          this.task.set(event.task);
          let formData: TAny;
          const courtId = this.getCourtNameData()?.courtId;

          formData = {
            caseCategory: this.task()?.caseCategory as ECaseCategory,
            judgementDate: this.task()?.hearingDate || '',
            judgementPhaseName: '',
            caseNumber: this.task()?.courtCaseNumber,
            triggeredTaskId: this.task()?.tasksId,
            taskTypeId: this.task()?.typeId,
            cphId: this.task()?.cphId,
            divisionId: this.task()?.divisionId
          }
          this.getJudgementCaseData(formData);
        }
      });
  }

  ngOnInit(): void {
    this.caseNumber.set('');
    this.selectedComment.set('');
    const courtId = this.getCourtNameData()?.courtId;
    if (courtId === 1 || courtId === 2) {
      if (courtId === 1) {
        this.breadcrumbs.set([{ label: 'Appeal' },
        { label: 'Judgement Schedule' },])
        this.isSupremeFlag = true;
      } else {
        this.breadcrumbs.set([{ label: 'Appeal' },
        { label: 'Judgement Schedule' },])
        this.isCOAflag = true
      }

    } else {
      this.breadcrumbs.set([{ label: 'Case' },
      { label: 'Judgement Schedule' },])
    };


  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSortRef;
    this.dataSource.sortingDataAccessor = (item: IJudgementData, property: string): string | number => {
      switch (property) {
        case 'caseNumber':
          return item.caseNumber || '';
        case 'plaintiff':
          return item.divisionName || '';
        case 'respondent':
          return item.courtUnitName || '';
        case 'judgementDate':
          return item.judgementDate ? new Date(item.judgementDate).getTime() : 0;
        default:
          const value = item[property as keyof IJudgementData];
          return typeof value === 'string' || typeof value === 'number' ? value : '';
      }
    };
  }

  public searchHandler() {
    this.caseNumber.set('');
    this.task.set(null)
    this.dataSource.data = [];
    if (this.searchForm.valid) {
      const formData = this.searchForm.value;
      this.getJudgementCaseData(formData);
    }
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }
  }
  public clearAllHandler(): void {
    this.searchForm.reset({ caseNumber: '' });
    this.getJudgementCaseData('');
  }

  public resetHandler() {
    this.isLoading = false;
    this.searchForm.reset();
    this.dataSource = new MatTableDataSource<IJudgementData>();

  }
  private getJudgementCaseData(formData: TAny) {
    const courtId = this.getCourtNameData()?.courtId;
    const effectiveCategory = (courtId === 1 || courtId === 2) ? this.caseCategoryEnum.A : formData.caseCategory;

    const queryParams: ISearchRequestParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'caseId',
      direction: 'ASC',
    };

    this.isLoading = true;

    this.service.getJudgementdataSearch(formData, queryParams)
      .subscribe({
        next: (res: IResponse<TAny[]>) => {
          // 1. Handle empty or missing data array immediately
          if (!res.data || res.data.length === 0) {
            this.dataSource.data = [];
            this.isLoading = false;
            this.cdr.detectChanges();
            return; // Stop execution here
          }

          // 2. Set the appeal flag safely now that we know data exists
          this.isAppeal = res.data[0].caseCategory === "A";

          // 3. Process the list items cleanly
          this.dataSource.data = res.data.map((item) => {
            return {
              ...item,
              editable: false,
              editedCtrlVal: item.judgementDate ? new Date(item.judgementDate) : new Date(),
              editedLoader: false
            };
          });

          this.isLoading = false;
          this.cdr.detectChanges();

          setTimeout(() => {
            if (this.matSortRef) {
              this.dataSource.sort = this.matSortRef;
              console.log('✅ MatSort initialized after data load');
            } else {
              console.warn('❌ MatSort not available after search');
            }
          });
        },
        error: () => {
          this.dataSource.data = [];
          this.isLoading = false;
          this.cdr.detectChanges(); // Ensure UI reflects error state
        }
      });
  }

  public onEditToggle(row: IJudgementData): void {
    row.editable = !row.editable;
    if (row.editable) {
      row.originalJudgementDate = row.judgementDate ? new Date(row.judgementDate).toISOString() : null;
      row.editedCtrlVal = row.judgementDate ? new Date(row.judgementDate) : new Date();
    }
  }

  public onCancel(row: IJudgementData): void {
    row.editable = false;
    if (row.originalJudgementDate !== undefined) {
      row.judgementDate = row.originalJudgementDate;
      row.editedCtrlVal = row.originalJudgementDate ? new Date(row.originalJudgementDate) : new Date();
    }
  }

  public isSaveDisabled(row: IJudgementData): boolean {
    if (!row.editedCtrlVal) {
      return true;
    }
    const originalTime = row.originalJudgementDate;
    const currentTime = row.editedCtrlVal ? new Date(row.editedCtrlVal).getTime() : null;
    return originalTime === currentTime;
  }

  public onSave(row: IJudgementData): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: 'Do you want to Save?',
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateRow(row);
      }
    });
  }

  private updateRow(row: IJudgementData): void {
    row.editedLoader = true;

    const reqBody: TAny = {
      caseId: row.caseId,
      casePhaseId: row.casePhaseId,
      cptId: row.cptId,
      docTypeId: row.docTypeId,
      courtUnitId: row.courtUnitId,
      triggeredTaskId: this.task()?.tasksId,
      judgementDate: formatDate(row.editedCtrlVal!, 'YYYY-MM-ddThh:mm:ss', 'en-US')
    };

    this.service.assignJudgementDate(reqBody).subscribe({
      next: (res: IResponse<any>) => {
        row.editedLoader = false; // Turn off loader on success
        row.editable = false;

        if (res.success) {
          const isError = !res.message.includes('Saved Successfully');
          this.dialogService.openDialog1({
            data: {
              title: isError ? 'Error' : 'Message',
              message: res.message || (isError ? 'Something went wrong' : 'Record updated successfully'),
              icon: isError ? 'error' : 'done_outline',
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });

          if (res.message.includes('Saved Successfully')) {
            row.judgementDate = row.editedCtrlVal?.getTime().toString() ?? '';
            this.dashboard.refreshSidebarTasks();
          }
        }
      },
      error: (err) => {
        // --- CATCH ERROR BLOCK ---
        row.editedLoader = false; // Ensures loader stops spinning on 500/400 network failures

        console.error('Judgement assignment failed:', err);

        this.dialogService.openDialog1({
          data: {
            title: 'Error',
            message: err?.error?.message || 'A server error occurred while updating the record.',
            icon: 'error',
          },
          disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
      }
    });
  }

  getCaseDetails(row: IJudgementData) {
    if (!(this.getCourtNameData()?.courtId === 1 || this.getCourtNameData()?.courtId === 2)) {
      this.caseNumber.set(row.caseNumber);
      this.selectedComment.set(row.comments ?? '')
      if (row.caseCategory === 'A') { this.isAppeal = true; console.log('isappealtrue') }
    }
    else {
      this.ispanel = true;
      this.caseNumber.set(row.caseNumber);
      this.selectedComment.set(row.comments ?? '')
      // this.originalPanelJustice(row);

    }
  }
  // originalPanelJustice(row: IJudgementData,): void {
  //     if (row) {
  //       const reqParams: TAny = {
  //         id: row.uniqueIdProperty,
  //         caseId: row.caseId,
  //         caseNumber: row.caseNumber,
  //         hearingPhaseName: row.judgementPhaseName,
  //         hearingPhaseId: row.jud,
  //         hearingDate: formatDate(row.hearingDate, 'YYYY-MM-ddThh:mm:ss', 'en-US'),
  //         sessionId: row.sessionId,
  //         sessionName: row.sessionName,
  //         panelId: row.panelId,
  //         panelName: row.panelName,
  //         courtUnitTypeId: row.courtUnitTypeId,
  //         courtUnitTypeName: row.courtUnitTypeName,
  //         triggeredTaskId: row.triggeredTaskId,
  //         uniqueIdProperty: row.uniqueIdProperty,
  //         transType: '',
  //         cphId: row.cphId
  //       };

  //       this.isOriginalPanelLoading = true;
  //       this.service.fetchOriginalJusticePanel(reqParams).subscribe({
  //         next: (res: IResponse<IJusticePanel[]>) => {
  //           this.originalPanel = res.data || res.success || [];
  //           this.isOriginalPanelLoading = false;
  //         },
  //         error: () => {
  //           this.isOriginalPanelLoading = false;
  //         }
  //       });
  //     }
  //     this.changedPanelJustice(row);
  //   }
  //   changedPanelJustice(row: ILocalHearingSchedule,): void {
  //     if (row) {
  //       const reqParams: TAny = {
  //         id: row.uniqueIdProperty,
  //         caseId: row.caseId,
  //         caseNumber: row.caseNumber,
  //         hearingPhaseName: row.hearingPhaseName,
  //         hearingPhaseId: row.hearingPhaseId,
  //         hearingDate: formatDate(row.hearingDate, 'YYYY-MM-ddThh:mm:ss', 'en-US'),
  //         sessionId: row.sessionId,
  //         sessionName: row.sessionName,
  //         panelId: row.panelId,
  //         panelName: row.panelName,
  //         courtUnitTypeId: row.courtUnitTypeId,
  //         courtUnitTypeName: row.courtUnitTypeName,
  //         triggeredTaskId: row.triggeredTaskId,
  //         uniqueIdProperty: row.uniqueIdProperty,
  //         transType: '',
  //         cphId: row.cphId
  //       };

  //       this.isChangedPanelLoading = true;
  //       this.service.fetchChangedJusticePanel(reqParams).subscribe({
  //         next: (res: IResponse<IJusticePanel[]>) => {
  //           this.changedPanel = res.data || res.success || [];
  //           this.isChangedPanelLoading = false;
  //         },
  //         error: () => {
  //           this.isChangedPanelLoading = false;
  //         }
  //       });
  //     }
  //   }
}
